import { _post, _get, _delete } from "./Axios";

export default class KpiUsulanApi {
  static get(id = null) {
    if (id == null) {
      return _get("kpi/usulan/assignment");
    } else {
      return _get("kpi/usulan/assignment/" + id);
    }
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("kpi/usulan/assignment?" + params);
  }
  static getDetail(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("kpi/usulan/detail?" + params);
  }
  static create(data) {
    return _post("kpi/usulan/assignment", data);
  }
  static update(id, data) {
    return _post("kpi/usulan/assignment/" + id, data);
  }
  static delete(id) {
    return _delete("kpi/usulan/assignment/" + id);
  }
  static action(data) {
    return _post("kpi/usulan/action", data);
  }
}
